import api from '@/api/index';
import _ from 'lodash';
let mutations = {
  setUserInfo(state, data) {
    if (JSON.parse(sessionStorage.getItem('userInfo'))) {
      state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    } else {
      state.userInfo = data;
    }
  },
  // z字典项
  dictionary(state, data) {
      state.dictionary = data;
  },
  setScreenWidth(state, data) {
    state.screenWidthType = data
  },
  setSearch(state, data) {
    state.search = data
  },
  setVideoToText(state,data){
    state.videoToText = data
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js